module.exports = __webpack_public_path__ + "img/about-m-slide-19.2330dc75.jpg";